<template>
  <dxy-modal v-model="insideModalOpen"
             :title="title"
             :width="dialogWidth"
             :okAutoClose="false"
             :closable="closable"
             :okText="okText"
             :loading="innerLoading"
             :cancelText="cancelText"
             :fullscreen="fullscreen"
             :fullscreenAble="fullscreenAble"
             :footerHide="footerHide"
             :maskClassName="maskClassName"
             :styles="styles"
             :className="className"
             @on-cancel="onClickCancelBtn"
             @on-start-request="onStartRequest($event)"
             @on-save-item-success="saveItemSuccess($event)"
             @on-change-screen="onChangeScreen($event)"
  >
    <slot name="viewContent">
      <p>请添加您的视图页面</p>
    </slot>
    <template slot="footer">
      <slot name="actionBar"></slot>
    </template>
  </dxy-modal>
</template>

<script>
import dxyModal from './../../dxy-modal/dxy-modal'

export default {
  name: 'simple-pop-modal',
  components: { dxyModal },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    dialogWidth: {
      type: [Number, String],
      default: 520
    },
    totalScreen: {
      type: Boolean,
      default: false
    },
    fullscreenAble: {
      type: Boolean,
      default: false
    },
    successOperatorCallBack: { type: Function, default: () => {} },
    footerHide: {
      type: Boolean,
      default: false
    },
    okText: {
      type: String
    },
    cancelText: {
      type: String
    },
    styles: {
      type: Object,
      default: () => {}
    },
    maskClassName: {
      type: String
    },
    className: {
      type: String
    }
  },
  data () {
    return {
      insideModalOpen: false,
      innerLoading: false,
      fullscreen: this.totalScreen
    }
  },
  watch: {
    value (val) {
      this.insideModalOpen = val
    },
    insideModalOpen (val) {
      this.$emit('input', val)
    },
    loading (val) {
      this.innerLoading = val
    }
  },
  methods: {
    onStartRequest (val) {
      this.innerLoading = !!val
    },
    onChangeScreen () {
      this.fullscreen = !this.fullscreen
      this.$emit('on-screen', this.fullscreen)
    },
    onClickCancelBtn (data) {
      this.$emit('on-cancel', data)
      this.insideModalOpen = false
    },
    saveItemSuccess (result) {
      if (result) {
        this.insideModalOpen = false
        this.successOperatorCallBack()
      }
      this.innerLoading = false
    }
  }
}
</script>

<style scoped>

</style>
